import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import isToday from 'dayjs/plugin/isToday';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/ja';
import 'dayjs/locale/vi';

dayjs.extend(updateLocale);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(isToday);

dayjs.locale('ja');

// Configure Japanese locale with custom meridiem format
dayjs.updateLocale('ja', {
  meridiem: (hour: number): string => (hour < 12 ? '午前' : '午後'),
  meridiemParse: /午前|午後/,
  isPM(input: string) {
    return input === '午後';
  },
});

/**
 * App-wide timezone — driven by VITE_APP_TIMEZONE env variable.
 * Defaults to 'Asia/Tokyo' (production Japan) when not set.
 */
export const APP_TIMEZONE: string = import.meta.env.VITE_APP_TIMEZONE || 'Asia/Tokyo';

dayjs.tz.setDefault(APP_TIMEZONE);

export type Dayjs = dayjs.Dayjs;

export type { ConfigType } from 'dayjs';

export default dayjs;
